import { syncSessionData, type SyncElement, type SyncSessionData } from '../util/session_sync'

up.compiler(
  '[data-sync-session-data]',
  { priority: 2 },
  (element: HTMLElement, data: SyncSessionData) => {
    const syncElement = element as SyncElement
    // System specs wait on this
    syncElement.waitForSync = syncSessionData(data)
  },
)
